exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".editor--box--3VwGmwsf {\r\n  margin-top: 8px;\r\n  flex-grow: 1;\r\n}\r\n\r\n.editor--displayBox--P52z_ZX1 {\r\n  padding: 0px 16px 0px 16px;\r\n  min-height: 300px;\r\n  display: block;\r\n}\r\n\r\n.editor--container--if-ATGSz {\r\n  margin-right: 1px;\r\n  display: block;\r\n}\r\n\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/editorContainer/editor.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;CACd;;AAED;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;CAChB;;AAED;EACE,kBAAkB;EAClB,eAAe;CAChB","file":"editor.css","sourcesContent":[".box {\r\n  margin-top: 8px;\r\n  flex-grow: 1;\r\n}\r\n\r\n.displayBox {\r\n  padding: 0px 16px 0px 16px;\r\n  min-height: 300px;\r\n  display: block;\r\n}\r\n\r\n.container {\r\n  margin-right: 1px;\r\n  display: block;\r\n}\r\n\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"box": "editor--box--3VwGmwsf",
	"displayBox": "editor--displayBox--P52z_ZX1",
	"container": "editor--container--if-ATGSz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/editorContainer/editor.css
// module id = 407
// module chunks = 0